function lhInitMenu() {
  const toggleBtn = document.getElementById('lh-menu-toggle');
  const menu = document.getElementById('lh-mega-menu');
  const overlay = document.getElementById('lh-overlay');

  if (!toggleBtn || !menu || !overlay) return;
  if (toggleBtn.dataset.init === 'true') return;

  toggleBtn.dataset.init = 'true';

  const level1Items = menu.querySelectorAll('.lh_level-1 .lh_menu-item');
  const level2Items = menu.querySelectorAll('.lh_level-2 .lh_menu-item');
  const level2Submenus = menu.querySelectorAll('.lh_level-2 .lh_submenu');
  const level3Submenus = menu.querySelectorAll('.lh_level-3 .lh_submenu');

  function clearCurrent(items) {
    items.forEach(item => item.classList.remove('lh_current'));
  }

  function resetMenuState() {
    menu.classList.remove('lh_show-level-2', 'lh_show-level-3');

    level2Submenus.forEach(el => el.classList.remove('lh_active'));
    level3Submenus.forEach(el => el.classList.remove('lh_active'));

    clearCurrent(level1Items);
    clearCurrent(level2Items);
  }

  function openLevel2(parentHandle, currentItem) {
    level2Submenus.forEach(el => el.classList.remove('lh_active'));
    level3Submenus.forEach(el => el.classList.remove('lh_active'));
    clearCurrent(level1Items);
    clearCurrent(level2Items);

    if (currentItem) currentItem.classList.add('lh_current');

    const target = menu.querySelector(`.lh_level-2 .lh_submenu[data-parent="${parentHandle}"]`);

    if (target) {
      menu.classList.add('lh_show-level-2');
      menu.classList.remove('lh_show-level-3');
      target.classList.add('lh_active');
    } else {
      menu.classList.remove('lh_show-level-2', 'lh_show-level-3');
    }
  }

  function openLevel3(parentHandle, currentItem) {
    level3Submenus.forEach(el => el.classList.remove('lh_active'));
    clearCurrent(level2Items);

    if (currentItem) currentItem.classList.add('lh_current');

    const target = menu.querySelector(`.lh_level-3 .lh_submenu[data-parent="${parentHandle}"]`);

    if (target) {
      menu.classList.add('lh_show-level-3');
      target.classList.add('lh_active');
    } else {
      menu.classList.remove('lh_show-level-3');
    }
  }

  function openMenu() {
    toggleBtn.classList.add('lh_active');
    menu.classList.add('lh_active');
    overlay.classList.add('lh_active');
    toggleBtn.setAttribute('aria-expanded', 'true');

    resetMenuState();
  }

  function closeMenu() {
    toggleBtn.classList.remove('lh_active');
    menu.classList.remove('lh_active', 'lh_show-level-2', 'lh_show-level-3');
    overlay.classList.remove('lh_active');
    toggleBtn.setAttribute('aria-expanded', 'false');

    level2Submenus.forEach(el => el.classList.remove('lh_active'));
    level3Submenus.forEach(el => el.classList.remove('lh_active'));
    clearCurrent(level1Items);
    clearCurrent(level2Items);
  }

  toggleBtn.addEventListener('click', () => {
    const isActive = toggleBtn.classList.contains('lh_active');

    if (isActive) {
      closeMenu();
    } else {
      openMenu();
    }
  });

  overlay.addEventListener('click', closeMenu);
    const panel = menu.querySelector('.lh_menu-panel');

  if (panel) {
    panel.addEventListener('click', (e) => {
      if (!e.target.closest('.lh_menu-item')) {
        closeMenu();
      }
    });
  }
  level1Items.forEach(item => {
    item.addEventListener('mouseenter', () => {
      if (!menu.classList.contains('lh_active')) return;
      openLevel2(item.dataset.handle, item);
    });
  });

  level2Items.forEach(item => {
    item.addEventListener('mouseenter', () => {
      if (!menu.classList.contains('lh_active')) return;
      openLevel3(item.dataset.handle, item);
    });
  });
}

lhInitMenu();
document.addEventListener('DOMContentLoaded', lhInitMenu);
document.addEventListener('shopify:section:load', lhInitMenu);

let lhTryCount = 0;
const lhMenuTimer = setInterval(() => {
  lhInitMenu();
  lhTryCount++;
  if (document.getElementById('lh-menu-toggle')?.dataset.init === 'true' || lhTryCount > 20) {
    clearInterval(lhMenuTimer);
  }
}, 300);